// extracted by mini-css-extract-plugin
export default {"h1":"title_h1__Lqp6M","h2":"title_h2__+leik","h3":"title_h3__JPB5K","h4":"title_h4__Q2nQx","colorPrimary":"title_colorPrimary__BS3gB","colorSecondary":"title_colorSecondary__aFPT2"};